import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wol-commonmodals',
  templateUrl: './commonmodals.component.html',
  styleUrls: ['./commonmodals.component.scss']
})
export class CommonmodalsComponent implements OnInit {

  @Input() type: string;
  @Input() title: string;
  @Input() text: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
